import { Component, OnInit } from '@angular/core';
import { AccountMixin } from 'src/app/services/mixins/account.mixin';
import { PageService } from 'src/app/services/page.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { InfoService } from 'src/app/services/info.service';
import { Observable } from 'rxjs';

import { Select } from '@ngxs/store';
import { UserState } from 'src/app/store/states/user.state';


import { PaymentService } from '@services/payment.service';

import { WindowRefService } from '@shared/window-ref';

import { TranslateService } from '@ngx-translate/core';

import { BaseComponent } from '../../base.component';

import { UserService } from '@/services/user.service';


@Component({
    selector: 'app-account-delete',
    templateUrl: './account-delete.component.html',

})
export class AccountDeleteComponent extends AccountMixin(BaseComponent)
    implements OnInit {
    @Select(UserState.lastSign)
    public lastSign$: Observable<any | null>;

    @Select(UserState.data) public userData$: Observable<Record<string, any>>;

    public actualTime: any;


    public userData: Record<string, any>;

    private sessionId: string;

    public deleteFailed: boolean = false;
    public deleteSuccess: boolean = false;

    public constructor(
        protected page: PageService,
        protected router: ActivatedRoute,
        public payment: PaymentService,
        protected win: WindowRefService,
        protected title?: Title,
        protected meta?: Meta,
        protected route?: Router,
        protected info?: InfoService,
        private translate?: TranslateService,
        private user?: UserService,

    ) {
        super(page, title, meta, route, info);
    }

    public ngOnInit(): void {
        super.ngOnInit();


        this.userData$.subscribe(((val) => {
            this.userData = val;
        }));
    }

    public delete(): void {
        this.deleteFailed = false;
        this.deleteSuccess = false;
        // eslint-disable-next-line no-restricted-globals, no-alert
        // eslint-disable-next-line no-restricted-globals, no-alert
        if (confirm(this.translate!.instant('web.account_delete_text'))) {
            this.user?.delete().subscribe(() => {
                this.deleteSuccess = true;
                setTimeout(() => {
                    this.route?.navigate(['/']);
                }, 5000);
            }, () => {
                this.deleteFailed = true;
            });
        }
    }
}
